"use strict";
/**
 * 自选股
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZXGBox1Table = void 0;
var react_1 = __importDefault(require("react"));
// import useSWR from "swr";
// import { getZXGDefaultGroupList } from "../../../../modules/zxg";
var small_1 = require("../../../quotetable/small");
var mobx_react_lite_1 = require("mobx-react-lite");
var observe_1 = require("./observe");
var mobx_1 = require("mobx");
/**
 * 首页自选股table
 * @returns
 */
function ZXGBoxTable() {
    // const { data, error } = useSWR(`zxglist`, ()=> getZXGDefaultGroupList(),{
    //   refreshInterval: 30 * 60 * 1000,
    //   dedupingInterval: 29 * 60 * 1000
    // })
    var _a, _b;
    if (observe_1.observedata == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var data = (0, mobx_1.toJS)((_b = (_a = observe_1.observedata === null || observe_1.observedata === void 0 ? void 0 : observe_1.observedata.zxgdata) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.list) || [];
    return (react_1.default.createElement("div", { className: "zxgbox1table" }, data &&
        react_1.default.createElement(small_1.QuoteSmallTable, { quotecode: data.slice(0, 5),
            table_key: 'ZXGSTable',
            count: 5,
            order: '',
            orderdur: 1 })));
}
exports.ZXGBox1Table = (0, mobx_react_lite_1.observer)(ZXGBoxTable);
